module.exports = __webpack_public_path__ + "static/img/default-img@2x.88aa84e0.png";